        <app-table [analytic]="true" [pageNation]="false" [paginationPageSizeSelector]="[10,20,50]" [maxRowCount]="totalCount"  (onPageChange)="handlePageChange($event)"></app-table>
